import { BackgroundColorsModel, IframeInitiator, Nullable } from '@lerna-core';

// TODO: переделать кастомизацию бэкграунда на ответ из бэка
const GREY_COLOR = '#F0F3F6';

export const getBackgroundColors = (
  initiator?: Nullable<IframeInitiator>
): BackgroundColorsModel => {
  switch (true) {
    case initiator === IframeInitiator.edstein:
    case initiator === IframeInitiator.finincubator:
      return {
        backgroundLayer0Styles: `background: #FFF;`,
        backgroundLayer1Styles: `background: #FFF;`,
        backgroundLayer2Styles: `background: #FFF;`,
      };
    default:
      return {
        backgroundLayer0Styles: `background: ${GREY_COLOR};`,
        backgroundLayer1Styles: `background: ${GREY_COLOR};`,
        backgroundLayer2Styles: `background: ${GREY_COLOR};`,
      };
  }
};
